import * as actionTypes from "./hazardActionTypes";
import * as actions from "./hazardActions";

export const addHazardFile = (fileId) => (dispatch) => {
  dispatch({
    type: actionTypes.ADD_HAZARD_FILE,
    payload: fileId,
  });
  dispatch(actions.updateHazardProfileSummary());
};

export const hideHazardFile = (key) => (dispatch) => {
  dispatch({
    type: actionTypes.HIDE_HAZARD_FILE,
    payload: key,
  });
  dispatch(actions.updateHazardProfileSummary());
};

export const updateHazardProfileSummary = () => ({
  type: actionTypes.UPDATE_HAZARD_PROFILE_SUMMARY,
});

export const updateHazardProfileSummaryStarted = () => ({
  type: actionTypes.UPDATE_HAZARD_PROFILE_SUMMARY_STARTED,
});

export const updateHazardProfileSummarySucceeded = (hazardProfileSummary) => ({
  type: actionTypes.UPDATE_HAZARD_PROFILE_SUMMARY_SUCCEEDED,
  payload: hazardProfileSummary,
});

export const updateHazardProfileSummaryFailed = () => ({
  type: actionTypes.UPDATE_HAZARD_PROFILE_SUMMARY_FAILED,
});
